var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSchedule = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.1 21H8c-2.2 0-4-1.8-4-4V9c0-2.2 1.8-4 4-4h8c2.2 0 4 1.8 4 4v5c.7 0 1.4.1 2 .4V9c0-3.3-2.7-6-6-6H8C4.7 3 2 5.7 2 9v8c0 3.3 2.7 6 6 6h6.8c-.3-.6-.6-1.3-.7-2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 1c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1s-1-.4-1-1V2c0-.6.4-1 1-1M8 1c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1s-1-.4-1-1V2c0-.6.4-1 1-1M2 10c0-.6.4-1 1-1h18c.6 0 1 .4 1 1s-.4 1-1 1H3c-.6 0-1-.4-1-1"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 4,
  style: {
    fill: "#ef5d54"
  }
}));
export default SvgIcSchedule;